import { ComponentType } from 'react';
import styled from 'styled-components';
import { COLORS } from '../../style';

interface IndustryCardProps {
  title: string;
  Icon: ComponentType;
}

const CardContainer = styled.div`
  background: ${COLORS.white};
  border: 2px solid transparent;
  border-radius: 16px;
  padding: 24px;
  display: flex;
  align-items: center;
  gap: 16px;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(15, 61, 76, 0.08);
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    width: 4px;
    background: linear-gradient(180deg, ${COLORS.blue} 0%, ${COLORS.green} 100%);
    transform: scaleY(0);
    transition: transform 0.3s ease;
  }

  &:hover {
    transform: translateX(8px);
    box-shadow: 0 8px 20px rgba(15, 61, 76, 0.15);
    border-color: ${COLORS.blue};

    &::before {
      transform: scaleY(1);
    }

    svg {
      transform: scale(1.15) rotate(-5deg);
      color: ${COLORS.green};
    }
  }

  svg {
    font-size: 36px;
    color: ${COLORS.blue};
    transition: all 0.3s ease;
    flex-shrink: 0;
  }

  h2 {
    font-size: 18px;
    color: ${COLORS.blue};
    font-weight: 600;
    margin: 0;
  }
`;

const IndustryCard = ({ title, Icon }: IndustryCardProps) => {
  return (
    <CardContainer>
      <Icon />
      <h2>{title}</h2>
    </CardContainer>
  );
};

export default IndustryCard;
